module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAMCAMAAACz+6aNAAAANlBMVEX///8AAAD///////////////////////////////////////////////////////////////9TvwflAAAAEnRSTlPMAKMLiXKdlI7Hgn5hVj80JhGSPRADAAAARUlEQVQI12XISRKAIAxFwRcCgrPe/7KW9RdG6GVjcl9uovEMcwnjiVfTKCRrFF9hPkEsLAasxs7fSeumUIfZujnwmqLFHoHAASjmoJDzAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/imgs/top.png
// module id = Ji+X
// module chunks = 1